import SeriesQ from '@/queries/SeriesQ'
import SessionQ from '@/queries/SessionQ'
import TopicQ from '@/queries/TopicQ'
import UserQ from '@/queries/UserQ'
import { SQL, type SQLFragment } from '@/client/query'

export type SearchCategory = 'Tutors' | 'Series' | 'Sessions'

export const CATEGORY_TO_SEARCH_FILTER: Record<
  SearchCategory,
  (searchParam: string) => SQLFragment<unknown>
> = {
  Tutors: (searchParam: string) => {
    if (searchParam.length === 0) {
      return SQL`TRUE`
    }
    const payload = `%${searchParam}%`
    return SQL`(${UserQ.display_name} ILIKE ${payload} OR ${UserQ.username} ILIKE ${payload} OR LEFT(${UserQ.bio}, 750) ILIKE ${payload})`
  },
  Sessions: (searchParam: string) => {
    if (searchParam.length === 0) {
      return SQL`TRUE`
    }

    const payload = `%${searchParam}%`

    return SQL`(${SessionQ.title} ILIKE ${payload} OR ${SessionQ.description}::text ILIKE ${payload} OR ${TopicQ.name} ILIKE ${payload})`
  },
  Series: (searchParam: string) => {
    if (searchParam.length === 0) {
      return SQL`TRUE`
    }
    const payload = `%${searchParam}%`
    return SQL`(${SeriesQ.title} ILIKE ${payload} OR ${SeriesQ.description}::text ILIKE ${payload})`
  },
}

export const DEFAULT_CATEGORY_SORTS: Record<SearchCategory, SQLFragment<unknown>> = {
  Tutors: SQL`ORDER BY (SELECT ${UserQ.countUpcomingSessionsHostedByUser()}) DESC, ${
    UserQ.id
  } DESC`,
  Sessions: SQL`ORDER BY ${SessionQ.start_date} ASC`,
  Series: SQL`ORDER BY (SELECT ${SessionQ.start_date} ${SeriesQ.getNextSession()}) ASC`,
}
